import {
  Button,
  Logo,
  Spacer,
  useTheme,
  Toggle,
  Field,
  Error,
} from "@convergence/components";
import { Formik } from "formik";
import { Link, useSearchParams } from "react-router-dom";
// import { styled } from "twin.macro";
import * as Yup from "yup";
import { useLoginUsernamePasswordMutation } from "../graphql";

const loginSchema = Yup.object().shape({
  email: Yup.string().email().required(),
  password: Yup.string().required(),
});

export default function LoginUsernamePassword() {
  const [login, { data }] = useLoginUsernamePasswordMutation();
  const [searchParams] = useSearchParams();
  const { darkMode, setDarkMode } = useTheme();
  return (
    <div className="w-screen h-screen flex flex-col">
      <header className="bg-red-200 dark:bg-neutral-800 gap-2 font-bitter text-neutral-900 dark:text-neutral-200 border border-black flex h-16 items-center pr-4">
        <Link to="/" className="block mx-4 my-auto h-1/2">
          <Logo className={`w-8 h-8 dark:fill-white fill-neutral-800`} />
        </Link>
        <Link to="/">
          <li className="my-auto text-xl text-neutral-900 dark:text-neutral-100 underline-effect">
            Tinker
          </li>
        </Link>
        <p className="text-neutral-900 dark:text-neutral-100">|</p>
        <a
          href={import.meta.env.VITE_DOCS_URL}
          target="_blank"
          rel="noreferrer"
        >
          <li className="my-auto text-xl text-neutral-900 dark:text-neutral-100 underline-effect">
            Docs
          </li>
        </a>
        <Spacer />
        <Toggle on={darkMode} onChange={(on) => setDarkMode(on)} />
      </header>
      <main className="w-full  bg-neutral-300 dark:bg-neutral-600 h-full flex-grow grid place-items-center border-black border border-t-0">
        <Formik
          validateOnBlur
          initialValues={{ email: "", password: "" }}
          validationSchema={loginSchema}
          initialErrors={{}}
          onSubmit={async (values) => {
            const result = await login({ variables: values });
            if (result.data?.loginUsernamePassword.success) {
              const redirect = searchParams.get("redirect");
              if (redirect) {
                window.location.href = redirect;
              } else {
                window.location.href = import.meta.env.VITE_TINKER_URL;
              }
            }
          }}
        >
          {({
            errors,
            values,
            handleChange,
            handleBlur,
            touched,
            handleSubmit,
          }) => (
            <form
              className="bg-neutral-100 border-black border p-8 dark:bg-neutral-400"
              onSubmit={handleSubmit}
            >
              <h2 className="text-2xl">Login</h2>
              <Field
                placeholder="email"
                name="email"
                value={values.email}
                type="email"
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <Field
                placeholder="password"
                name="password"
                value={values.password}
                type="password"
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.email && touched.email && <Error>{errors.email}</Error>}
              {data?.loginUsernamePassword?.errors?.map((error) => (
                <div
                  className="mx-auto my-4 text-red-700"
                  key={`login error ${error}`}
                >
                  {error}
                </div>
              ))}
              <Button className="dark:bg-neutral-900 dark:text-neutral-100 bg-neutral-300 text-neutral-800 p-2 mt-2">
                Submit
              </Button>
              <a
                href={`${import.meta.env.VITE_TINKER_URL}/signup`}
                className="block text-center mt-4 underline"
              >
                Don't have an account? Register for our beta!
              </a>
            </form>
          )}
        </Formik>
      </main>
    </div>
  );
}
